var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import H5 from '../../typography/H5';
import { colors, opacities } from '../../../defaultTheme';
import CardRow from './CardRow';
import Inset from '../../spacing/Inset';
const CardBase = styled.div `
  overflow: hidden;
  background-color: ${colors.white};
  border-radius: 10px;
  box-shadow: 0 1px 10px 0 ${opacities.rgbaLight10},
    0 4px 5px 0 ${opacities.rgbaLight08}, 0 2px 4px 0 ${opacities.rgbaLight04};
  display: block;
  width: 100%;
`;
const Header = styled(CardRow) `
  display: flex;
  justify-content: space-between;
`;
const Title = styled(H5) `
  color: ${colors.black};
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TitleContainer = styled(Inset) `
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
export const Card = (_a) => {
    var { title = '', children, className, titleSibling, upperCase, weight } = _a, props = __rest(_a, ["title", "children", "className", "titleSibling", "upperCase", "weight"]);
    return (React.createElement(CardBase, Object.assign({ className: className }, props),
        title && (React.createElement(Header, { hasBorderBottom: true },
            React.createElement(TitleContainer, { horizontal: "small", vertical: "base" },
                React.createElement(Title, { weight: weight }, upperCase ? title.toUpperCase() : title),
                titleSibling || null))),
        children));
};
export default Card;
